import React, { useState, useEffect } from "react";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import BallotIcon from "@mui/icons-material/Ballot";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";

import { getKeyValueForBatches1, addBatches1, getBatchesUUID1, updateBatches1, getUnitKeyValueList, getAllActiveWareRecords } from "../../../services/index";

const BatchNew = (props) => {
    let { id } = useParams();
    const navigate = useNavigate();

    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString().substring(0, 10);

    const [edit, setEdit] = useState(true);
    const [dates, setDates] = useState({
        productionDate: date1,
        productionMfgDate: "",
        productionExpDate: "",
    });
    const [ware, setWare] = useState("");
    const [wareOptions, setWareOptions] = useState("");

    const [itemOptions, setItemOptions] = useState("");
    const [itemOptions2, setItemOptions2] = useState("");
    const [unitOptions, setUnitOptions] = useState("");

    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([
        {
            batchName: "",
            batchNo: "BA",
            itemId: "",
            itemTitle: "",
            quantity: 1,
            quantityUnitId: "",
            quantityUnitTitle: "",

            item: "",
        },
    ]);

    const { productionDate, productionMfgDate, productionExpDate } = dates

    useEffect(() => {
        let data = {
            page: 0,
            search: "",
            size: -1,
        };
        getAllActiveWareRecords(data).then((res) => {
            if (res.errorCode == 0) {
                const data = res.responsePacket.data;
                const options = data.map((d) => ({
                    value: d.recordId,
                    label: d.title,
                }));
                setWareOptions(options);
            } else {
                toast(res.message);
            }
        });

        getKeyValueForBatches1().then((res) => {
            if (res.errorCode == 0) {
                const data = res.responsePacket.data;
                const options = data.map((d) => ({
                    value: d,
                    label: d.title,
                    units: [
                        { value: d.itemUnitId, label: d.itemUnitTitle },
                        { value: d.weightUnitId, label: d.weightUnitTitle },
                    ],
                }));
                setItemOptions(options);
                setItemOptions2(options);
            } else {
                toast(res.message);
            }
        });

        getUnitKeyValueList().then((res) => {
            if (res.errorCode == 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setUnitOptions(options);
            } else {
                toast(res.message);
            }
        });
    }, []);

    useEffect(() => {
        if (id)
            getBatchesUUID1(id).then((res) => {
                if (res.errorCode == 0) {
                    const data = res.responsePacket;
                    setDates({
                        productionDate: data.productionDate || productionDate,
                        productionMfgDate: data.productionMfgDate || productionMfgDate,
                        productionExpDate: data.productionExpDate || productionExpDate,
                    })
                    setWare({ value: data.warehouseId, label: data.warehouseTitle });

                    getKeyValueForBatches1().then((res) => {
                        if (res.errorCode == 0) {
                            const ddd = res.responsePacket.data;
                            let arr = ddd.filter((a) => data.batchItemsList[0].itemId == a.recordId);
                            let obj = arr[0];
                            setRows([
                                {
                                    batchName: data.batchItemsList[0].batchName,
                                    batchNo: "BA",
                                    itemId: data.batchItemsList[0].itemId,
                                    itemTitle: data.batchItemsList[0].itemTitle,
                                    quantity: data.batchItemsList[0].quantity,
                                    quantityUnitId: data.batchItemsList[0].quantityUnitId,
                                    quantityUnitTitle: data.batchItemsList[0].quantityUnitTitle,

                                    item: {
                                        value: data.batchItemsList[0].itemId,
                                        label: data.batchItemsList[0].itemTitle,
                                    },
                                    unit1: {
                                        value: data.batchItemsList[0].quantityUnitId,
                                        label: data.batchItemsList[0].quantityUnitTitle,
                                    },
                                    units: [
                                        { value: obj?.itemUnitId, label: obj?.itemUnitTitle },
                                        { value: obj?.weightUnitId, label: obj?.weightUnitTitle },
                                    ],
                                },
                            ]);
                        } else {
                            toast(res.message);
                        }
                    });
                } else {
                    toast(res.message);
                }
            });
    }, []);

    const handlAddRow = () => {
        setRows([
            ...rows,
            {
                batchName: "",
                batchNo: "BA",
                itemId: "",
                itemTitle: "",
                quantity: 1,
                quantityUnitId: "",
                quantityUnitTitle: "",

                item: "",
            },
        ]);
    };

    const handleClear = (id, i) => {
        let obj = [...rows];
        obj.splice(i, 1);
        setRows(obj);
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].item = e;
        obj[i].itemId = e.value.recordId;
        obj[i].itemTitle = e.value.title;
        obj[i].units = e.units;
        obj[i].unit1 = e.units[1];
        obj[i].quantityUnitId = e.units[1].value;
        obj[i].quantityUnitTitle = e.units[1].label;

        setRows(obj);

        handleFilterItems(obj);
    };

    const handleFilterItems = (rows) => {
        var setSend = false;
        var filterOptions = [];
        itemOptions2 &&
            itemOptions2.map((a) => {
                rows &&
                    rows.map((b) => {
                        if (a.value === b?.item?.value) {
                            setSend = true;
                        }
                    });
                if (!setSend) {
                    filterOptions.push(a);
                }
                setSend = false;
            });
        setItemOptions(filterOptions);
    };

    const handleQty = (e, i) => {
        const obj = [...rows];
        if (e.target.value >= 0) {
            obj[i].quantity = Number(e.target.value);
            setRows(obj);
        }
    };

    const handleUnit = (e, i) => {
        const obj = [...rows];
        obj[i].quantityUnitId = e.value;
        obj[i].quantityUnitTitle = e.label;
        obj[i].unit1 = { value: e.value, label: e.label };
        setRows(obj);
    };

    const handleBatch = (e, i) => {
        const obj = [...rows];
        obj[i].batchName = e.target.value;
        setRows(obj);
    };

    const handleSaveBatch = () => {
        if (!ware?.label) {
            toast("select warehouse");
            return;
        }

        if (!productionMfgDate) {
            toast("Please select Mfg. date");
            return;
        }

        if (!productionExpDate) {
            toast("Please select expire date");
            return;
        }

        setLoading(true);
        const arr = rows.filter((a) => a.itemId && a.batchName && a.quantityUnitId);

        const request = {
            batchItemsList: arr,
            productionDate, productionMfgDate, productionExpDate,
            warehouseId: ware.value,
            warehouseTitle: ware.label,
        };

        if (id != null) {
            request.recordId = id;
            updateBatches1(id, request)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        navigate("/batches");
                        setLoading(false);
                    } else {
                        toast(res.message);
                        setLoading(false);
                        return;
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        } else {
            addBatches1(request)
                .then((res) => {
                    if (res.errorCode === 0) {
                        toast(res.message);
                        navigate("/batches");
                        setLoading(false);
                    } else {
                        toast(res.message);
                        setLoading(false);
                        return;
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    return;
                });
        }
    };

    const handleDatesChange = (e) => {
        const { name, value } = e.target
        setDates(prev => ({ ...prev, [name]: value }))
    }

    return (
        <>
            <div className="fill list-header d-flex justify-content-between align-items-center bg-white p-3 border-bottom">
                <h1 className="">
                    <BallotIcon />
                    {id ? "Edit" : "New"} Batch Production
                </h1>
            </div>

            <div style={{ paddingLeft: "15px", paddingTop: "15px" }}>
                <table className="customTable">
                    <tbody>
                        <tr>
                            <td>MFD Date</td>
                            <td>
                                <input autoComplete="off" disabled={edit ? false : true} className="form-control" type="date" name="productionMfgDate" onChange={handleDatesChange} value={productionMfgDate} />
                            </td>
                        </tr>
                        <tr>
                            <td>Expiry Date</td>
                            <td>
                                <input autoComplete="off" disabled={edit ? false : true} className="form-control" type="date" name="productionExpDate" onChange={handleDatesChange} value={productionExpDate} />
                            </td>
                        </tr>
                        <tr>
                            <td>Warehouse</td>
                            <td>
                                <Select options={wareOptions} placeholder={"Select WareHouse"} onChange={(e) => setWare(e)} value={ware} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr />
                <br />
                <table className="customTable">
                    <tbody>
                        <tr>
                            <td>Batch Name</td>
                            <td style={{ width: "200px" }}>Item</td>
                            <td>Qty</td>
                            <td>Unit</td>
                            <td></td>
                        </tr>

                        {rows.map((a, i) => {
                            return (
                                <tr key={i}>
                                    <td style={{ width: "250px" }}>
                                        <input autoComplete="off" className="form-control" onChange={(e) => handleBatch(e, i)} value={a.batchName} />
                                    </td>
                                    <td style={{ width: "350px" }}>
                                        <Select options={itemOptions} isDisabled = {id ?true : false} placeholder={"Select Item"} onChange={(e) => handleItem(e, i)} value={a.item} />
                                    </td>

                                    <td style={{ width: "100px" }}>
                                        <input autoComplete="off" className="form-control" type="number" min={id ? 0 : 1} onChange={(e) => handleQty(e, i)} value={a.quantity} />
                                    </td>
                                    <td style={{ width: "140px" }}>
                                        <Select
                                            // isDisabled={id?true:false}
                                            options={a.units}
                                            value={a.unit1}
                                            placeholder={"Select unit"}
                                            onChange={(e) => handleUnit(e, i)}
                                        />
                                    </td>

                                    {id ? (
                                        <></>
                                    ) : (
                                        <td>
                                            <i style={{ cursor: "pointer" }} className="fa fa-times" onClick={() => handleClear(a?.item.value, i)}></i>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                {id ? (
                    <></>
                ) : (
                    <div>
                        <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handlAddRow}>
                            <AddIcon style={{ color: "blue" }} /> New Row
                        </button>
                    </div>
                )}
                <br />
                <hr />
                <Button disabled={loading} variant="contained" onClick={handleSaveBatch}>
                    {loading ? <Spinner /> : "Save"}
                </Button>
            </div>
            <Toaster />
        </>
    );
};

export default BatchNew;
